const state = {
  tags: [],
  tagGroups: []
}

export default state
